<template>
	<vx-card>
		<vs-popup
			:active.sync="showMissionsPopup"
			:title="'Prestations du contrat N°' + selectedContract"
			style="z-index: 53002"
		>
			<!-- MISSIONS -->
			<div style="width: 1000px">
				<MissionPopupTable :missions="missionsOfSociety" />
			</div>
			<!-- /MISSIONS -->
		</vs-popup>
		<div class="vx-col">
			<div class="vx-row">
				<!-- BOUTON DE RETOUR -->

				<div class="vx-col sm:w-1/2 w-full mb-2">
					<div v-if="secondClose">
						<vs-button
							v-if="
								!showNetlinkPopup ||
								editPurchaseMode ||
								(showNetlinkPopup && atLeastOneNetlink)
							"
							class="float-right"
							radius
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-x"
							@click="returnPrevRoute"
						></vs-button>
					</div>
				</div>
				<!-- /BOUTON DE RETOUR -->
			</div>
			<div class="flex pr-5">
				<!-- CLIENT -->
				<div class="mt-4 w-1/2 small-field">
					<label for="" class="vs-select--label">Client</label>
					<div class="flex">
						<vs-select
							v-model="selectedSociety"
							class="w-full select-medium mr-2"
							:disabled="$props.societyId ? true : purchaseDefinitiveLock"
							autocomplete
							:style="styleValidator('selectedSociety')"
							@change="validateOne(selectedSociety, 'selectedSociety')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in societies"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedSociety'] &&
								validators['selectedSociety'].errText !== ''
							"
							:text="errText('selectedSociety')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<!-- /CLIENT -->

				<!-- CONTRAT -->
				<div class="mt-4 w-1/2 small-field">
					<label for="" class="vs-select--label">Contrat</label>
					<div class="flex">
						<vs-select
							autocomplete
							v-model="selectedContract"
							class="w-full select-medium mr-2"
							:disabled="$props.contractId ? true : purchaseLocked"
							no-data="Aucun contrat actif"
							:style="styleValidator('selectedContract')"
							@change="validateOne(selectedContract, 'selectedContract')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="
									$props.contractId
										? $props.contractId +
										  ' - ' +
										  $props.productsCategories[item.delivery - 1]
										: item.id + ' - ' + products_categories[item.delivery - 1]
								"
								v-for="(item, index) in contractOptions"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedContract'] &&
								validators['selectedContract'].errText !== ''
							"
							:text="errText('selectedContract')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
			</div>
			<!-- /CONTRAT -->

			<!-- PRESTATION -->
			<div class="vx-col sm:w-1/8 mb-2" v-if="type != 'DNS' && !orderId">
				<label for="" class="vs-select--label">Prestation</label>
				<div class="flex">
					<vs-select
						autocomplete
						v-model="selectedProduct"
						class="w-full select-medium mr-2"
						:disabled="purchaseLocked"
						no-data="Aucune prestation"
						:style="styleValidator('selectedProduct')"
						@change="validateOne(selectedProduct, 'selectedProduct')"
						id="product_options"
					>
						<vs-select-item
							:key="index"
							:value="item[0]"
							:text="item[1]"
							v-for="(item, index) in productOptions"
							class="w-full"
						/>
					</vs-select>
					<vx-tooltip
						v-if="
							validators['selectedProduct'] &&
							validators['selectedProduct'].errText !== ''
						"
						:text="errText('selectedProduct')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
			</div>
			<!-- /PRESTATION -->

			<div class="flex pr-5">
				<!-- SERVICE -->
				<div class="w-1/2 small-field">
					<label for="" class="vs-select--label">Service</label>
					<div class="flex">
						<vs-select
							v-model="selectedService"
							class="w-full select-medium mr-2"
							:disabled="purchaseDefinitiveLock"
							autocomplete
							:style="styleValidator('selectedService')"
							@change="validateOne(selectedService, 'selectedService')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in services"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedService'] &&
								validators['selectedService'].errText !== ''
							"
							:text="errText('selectedService')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<!-- /SERVICE -->

				<!-- PRESTATAIRE -->
				<div class="w-1/2 small-field">
					<label for="" class="vs-select--label">Prestataire</label>
					<div class="flex">
						<vs-select
							v-if="type == 'DNS' || is_dns"
							v-model="selectedProvider"
							class="w-full select-medium mr-2"
							:disabled="purchaseDefinitiveLock"
							autocomplete
							no-data="Aucun prestataire"
							:style="styleValidator('selectedProvider')"
							@change="validateOne(selectedProvider, 'selectedProvider')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.society"
								v-for="(item, index) in dnsProviders"
								class="w-full"
							/>
						</vs-select>
						<vs-select
							v-else
							v-model="selectedProvider"
							class="w-full select-medium mr-2"
							:disabled="purchaseDefinitiveLock"
							autocomplete
							no-data="Aucun prestataire"
							:style="styleValidator('selectedProvider')"
							@change="validateOne(selectedProvider, 'selectedProvider')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.society"
								v-for="(item, index) in providerOptions.filter(
									(e) => e.status == 1
								)"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedProvider'] &&
								validators['selectedProvider'].errText !== ''
							"
							:text="errText('selectedProvider')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
			</div>
			<!-- /PRESTATAIRE -->
		</div>

		<div class="flex pr-5 mt-5">
			<!-- PRIX D'ACHAT -->
			<div class="w-1/2 small-field">
				<div
					v-if="
						type != 'DNS' &&
						is_dns == false &&
						![netlinkServiceId, dnsServiceId].includes(selectedService)
					"
					class="flex"
				>
					<vs-input
						class="w-full"
						:disabled="purchaseLocked"
						label-placeholder="Prix d'achat"
						v-model="purchase.price"
						:style="styleValidator('price')"
						@change="validateOne(purchase.price, 'price')"
					/>
					<vx-tooltip
						v-if="validators['price'] && validators['price'].errText !== ''"
						:text="errText('price')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
				<!-- /PRIX D'ACHAT -->
			</div>
			<!-- REFACTURABLE -->

			<div v-if="type != 'DNS' && is_dns == false" class="w-1/2 small-field">
				<div class="flex" style="height: 100%">
					<vs-checkbox
						class="w-full"
						:disabled="purchaseLocked || lockBillable"
						v-model="purchase.isBillable"
						>Facturable</vs-checkbox
					>
				</div>
			</div>
			<!-- /REFACTURABLE -->
			<!-- Prix de vente -->
			<div
				v-if="type != 'DNS' && is_dns == false && purchase.isBillable"
				class="w-1/2 small-field"
			>
				<div class="flex">
					<vs-input
						class="w-full"
						:disabled="purchaseLocked"
						label-placeholder="Prix de vente"
						v-model="purchase.sellPrice"
						:style="styleValidator('sellPrice')"
						@change="validateOne(purchase.sellPrice, 'sellPrice')"
					/>
					€
					<vx-tooltip
						v-if="
							validators['sellPrice'] && validators['sellPrice'].errText !== ''
						"
						:text="errText('sellPrice')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
			</div>
			<!-- Prix de vente -->
			<!-- Periode -->
			<div class="w-1/2 small-field">
				<div class="flex">
					<vx-input-group class="w-full bottom">
						<label for="flatpickr" style="font-size: 9px; margin-left: 3px"
							>Période</label
						>
						<br />
						<flat-pickr
							class="w-full"
							id="flatpickr"
							v-model="period"
							:config="configDatePicker"
							@keydown.native.delete.capture.stop.prevent
						/>
					</vx-input-group>
				</div>
			</div>
			<!-- Prix de vente -->
		</div>

		<!-- MARGE PRIX
      <div v-if="type != 'DNS' && is_dns == false" class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          v-show="purchase.isBillable"
          class="w-full"
          :disabled="purchaseLocked"
          label-placeholder="Marge Prix"
          v-model.number="purchase.marginPrice"
          :style="styleValidator('marginPrice')"
          @change="validateOne(purchase.marginPrice, 'marginPrice')"
        />
        <vx-tooltip v-if="validators['marginPrice'] && validators['marginPrice'].errText !== ''" :text="errText('marginPrice')" class="ml-3">
          <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
        </vx-tooltip>
      </div>
       MARGE /PRIX -->
		<!-- MARGE TAUX
      <div v-if="type != 'DNS' && is_dns == false" class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          v-show="purchase.isBillable"
          class="w-full"
          :disabled="purchaseLocked"
          label-placeholder="Marge Taux"
          v-model.number="purchase.marginRate"
          :style="styleValidator('marginRate')"
          @change="validateOne(purchase.marginRate, 'marginRate')"
        />
        <vx-tooltip v-if="validators['marginRate'] && validators['marginRate'].errText !== ''" :text="errText('marginRate')" class="ml-3">
          <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
        </vx-tooltip>
      </div>
       MARGE /TAUX -->
		<!-- FREQUENCY -->
		<!-- <div class="vx-col sm:w-1/4 w-full mb-2" >
        <vs-select
          autocomplete
          v-model="purchase.recurrence"
          class="w-full select-medium mr-2"
          :disabled="purchaseLocked"
          label="Fréquence de la récurrence"
          placeholder=""
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in frequencyOptions"
            class="w-full"
          />
        </vs-select>
      </div> -->
		<!-- /FREQUENCY -->
		<!-- DATE -->
		<!-- <div class="vx-col sm:w-1/4 w-full mb-2">
      <vx-input-group
        class="w-full bottom"
      >
          <template slot="prepend">
            <div class="prepend-text bg-primary">
              <span class="flex"
                ><vs-icon icon="calendar_today" size="small"></vs-icon
              ></span>
            </div>
          </template>
          <flat-pickr
            class="w-full"
            v-model="purchase.boughtAt"
            :config="configEndDatePicker"
            placeholder="Date d'achat"
            :disabled="purchaseLocked"
            :style="styleValidator('boughtAt')"
            @input="validateOne(purchase.boughtAt, 'boughtAt')"
          />
        </vx-input-group>
        <vx-tooltip v-if="validators['boughtAt'] && validators['boughtAt'].errText !== ''" :text="errText('boughtAt')" class="ml-3">
          <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
        </vx-tooltip>
      </div> -->
		<!-- /DATE -->

		<!-- Commentaire -->
		<div class="flex mb-5">
			<vs-input
				v-model="purchase.commentary"
				label="Commentaire"
				class="w-full bottom"
				:disabled="purchaseLocked"
			/>
		</div>
		<!-- Commentaire -->

		<div class="vx-row justify-end">
			<div v-if="is_dns == false" class="vx-col">
				<vs-button
					v-if="purchaseLocked"
					class="float-right"
					color="primary"
					type="filled"
					@click="enterEditMode"
					>Modifier Achat
				</vs-button>
			</div>
			<div class="vx-col align-center" v-if="!is_dns && selectedContract">
				<vs-button color="primary" type="filled" @click="displayMissionsPopup"
					>Voir les prestations du contrat
				</vs-button>
			</div>
			<!-- NETLINK POPUP -->
			<div>
				<span
					v-show="
						(showNetlinkPopup && selectedService == netlinkServiceId) ||
						(atLeastOneNetlink && editPurchaseMode)
					"
					><NetlinkPopupTable
						ref="netlinkPopup"
						:purchaseId="purchaseId"
						:societyId="selectedSociety"
						@netlink-update="checkNetlinkNumber($event)"
				/></span>
				<!-- <span v-show="showNetlinkPopup || (atLeastOneNetlink && editPurchaseMode)"><NetlinkPopupTable ref="netlinkPopup" :purchaseId="purchaseId" :societyId="selectedSociety" @netlink-update="checkNetlinkNumber($event)"/></span> -->
				<span v-show="showDnsPopup && selectedService == dnsServiceId"
					><DnsPopupTable
						ref="dnsPurchasePopup"
						:purchaseId="purchaseId"
						:providerId="selectedProvider"
						:price="Number(purchase.price)"
				/></span>
			</div>
			<!-- /NETLINK POPUP -->
			<vs-button
				v-if="is_netlink && !showNetlinkPopup && !editPurchaseMode"
				class="mb-2"
				@click="formSubmittedAndShowNetlink"
				>Enregistrer et Ajouter Netlink</vs-button
			>
			<vs-button
				v-else-if="is_netlink && !showNetlinkPopup && editPurchaseMode"
				class="mb-2"
				@click="editFormSubmittedAndShowNetlink"
				>Enregistrer et Ajouter Netlink</vs-button
			>
			<vs-button
				v-else-if="
					is_dns && !showNetlinkPopup && !showDnsPopup && !editPurchaseMode
				"
				class="mb-2"
				@click="formSubmittedAndShowDns"
				>Enregistrer et Ajouter NDD</vs-button
			>
			<vs-button
				v-else-if="
					is_dns && !showNetlinkPopup && !showDnsPopup && editPurchaseMode
				"
				class="mb-2"
				@click="editFormSubmittedAndShowDns"
				>Enregistrer et Ajouter NDD</vs-button
			>
			<!-- <vs-button v-else-if="!showDnsPopup && !showNetlinkPopup && !editPurchaseMode" class="mb-2" @click="formSubmitted">Enregistrer Achat</vs-button>
        <vs-button v-else-if="!showDnsPopup && !showNetlinkPopup && editPurchaseMode" class="mb-2" @click="editFormSubmitted">Enregistrer Achat</vs-button>
        <vs-button v-else-if="showNetlinkPopup && atLeastOneNetlink" class="mb-2" @click="netlinkSubmitted">Enregistrer</vs-button>
        <vs-button v-else-if="showDnsPopup" class="mb-2" @click="dnsSubmitted">Enregistrer</vs-button> -->
			<vs-button v-else class="mb-2" @click="submitForm">Enregistrer</vs-button>
		</div>

		<div class="vx-row mt-3">
			<div class="vx-col w-full">
				<!-- REINITIALISER -->
				<!-- <vs-button
          color="warning"
          type="border"
          class="mb-2 mr-3"
          @click="
            purchase.firstname = purchase.lastname = purchase.email = purchase.phone = purchase.image_url = purchase.commentary = purchase.role =
              ''
          "
          >Réinitialiser</vs-button
        > -->
				<!-- /REINITIALISER -->
				<!-- SUBMIT -->

				<!-- /SUBMIT -->
			</div>
		</div>
	</vx-card>
</template>

<script>
import VueCookies from "vue-cookies";
import MissionPopupTable from "@/components/tables/MissionPopupTable";
import NetlinkPopupTable from "@/components/tables/NetlinkPopupTable";
import DnsPopupTable from "@/components/tables/DnsPopupTable";
import Validator from "@/entities/Validator";
import Purchase from "@/entities/Purchase";
import Contract from "@/entities/Contract";
import Mission from "@/entities/Mission";
import store from "@/store/store";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "PurchaseForm",
	mixins: [dbFieldConvertor],
	props: {
		chartParams: Object,
		isPercent: Boolean,
		type: String,
		contractId: {
			type: Number,
			default: null,
		},
		orderId: {
			type: Number,
			default: null,
		},
		productsCategories: {
			type: Array,
			default: null,
		},
		societyId: {
			type: Number,
			default: null,
		},
		url: {
			type: String,
			default: null,
		},
		secondClose: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		flatPickr,
		monthSelect,
		MissionPopupTable,
		NetlinkPopupTable,
		DnsPopupTable,
		VxTooltip,
	},
	data() {
		return {
			// USER OBJECT
			purchase: Purchase.getFormFields(),
			apiUrl: this.$props.url
				? this.$props.url
				: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			statusOptions: [
				{ text: "Actif", value: 1 },
				{ text: "Inactif", value: 0 },
			],
			frequencyOptions: [
				{ text: "One shot", value: 0 },
				{ text: "Mensuel", value: 1 },
				{ text: "Bimestriel", value: 2 },
				{ text: "Trimestriel", value: 3 },
				{ text: "Quadrimestriel", value: 4 },
				{ text: "Semestriel", value: 5 },
				{ text: "Annuel", value: 6 },
			],
			/**
			 * Refer to backend server to understand more about type and its possible value
			 */
			typeOptions: [
				{ text: "Commercial", value: 2 },
				{ text: "Consultant", value: 3 },
			],
			netlink_list: [],
			contractOptions: [],
			productOptions: [],
			providerOptions: [],
			serviceOptions: [],
			missionsOfSociety: [],
			selectedSociety: null,
			selectedContract: null,
			selectedProduct: null,
			selectedProvider: null,
			selectedService: null,
			purchaseLocked: false,
			purchaseDefinitiveLock: false,
			lockBillable: false,
			editPurchaseMode: false,
			is_netlink: false,
			is_netlinkclient: false,
			netlinkServiceName: "Netlinking",
			netlinkClientServiceName: "Netlinking Client",
			dnsClientServiceName: "Domaine Client",
			netlinkServiceId: null,
			netlinkClientServiceId: null,
			dnsClientServiceId: null,
			is_dns: false,
			is_dnsclient: false,
			dnsServiceName: "Domaine",
			dnsServiceId: null,
			oneDns: null,
			showNetlinkPopup: false,
			showDnsPopup: false,
			atLeastOneNetlink: false,
			atLeastOneDns: false,
			purchaseId: null,
			configEndDatePicker: {
				// minDate: new Date(),
				dateFormat: "j/n/Y",
			},
			showMissionsPopup: false,

			dnsProviders: [],
			dnsServices: [],
			validators: {},
			check: true,
			//period
			period: null,
			configDatePicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
		};
	},
	created() {
		// //console.log("Test: ", this.convertFrenchNumberToInternational("43,3"))
		let today = new Date(Date.now());
		this.purchase.boughtAt = today.toISOString();
		// this.configEndDatePicker.minDate = new Date(this.configEndDatePicker.minDate.getFullYear(), this.configEndDatePicker.minDate.getMonth(), 1)
		this.getAllSocieties();
		this.$store.dispatch("getAllProducts");
		this.getAllProviders();
		this.getAllServices();
		this.getAllProductsCategories();
		this.period = `${today.getMonth() + 1}/${today.getFullYear()}`;
		if (this.$props.societyId) {
			this.selectedSociety = this.$props.societyId;
			this.selectedContract = this.$props.contractId;
			this.products_categories = this.$props.productsCategories;
		}
	},
	mounted() {
		if (this.$props.societyId) {
			this.selectedSociety = this.$props.societyId;
			this.selectedContract = this.$props.contractId;
			this.setNetlinkAndDnsId();
			let today = new Date(Date.now());
			this.period = `${today.getMonth() + 1}/${today.getFullYear()}`;
		}
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		societies: () => {
			return store.state.societies;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		products: () => {
			return store.state.products;
		},
		products_categories: () => {
			return store.state.products_categories.map((row) => row.name);
		},
	},
	watch: {
		selectedSociety: function () {
			console.log("selectedSociety watch");
			this.purchase.contract_society_id = this.selectedSociety;
			this.getAllContractsForSociety(this.selectedSociety);
			if (this.is_dns) this.getAllMissionsForContract(1);
		},
		selectedContract: function () {
			//console.log("selectedContract watch");
			if (this.selectedService) this.setProviderOptions(this.selectedService);
			this.purchase.contract_id = this.selectedContract;
			if (this.is_dns) this.getAllMissionsForContract(1);
			else this.getAllMissionsForContract(this.selectedContract);
		},
		selectedProvider: function () {
			//console.log("selectedProvider watch");
			this.purchase.users_id = this.selectedProvider;
			/*
			 * this.serviceOptions = this.setServiceOptions(this.selectedProvider)
			 * this.selectedService = this.serviceOptions[0]
			 */
		},
		selectedService: function (data) {
			//console.log("selectedService watch");
			this.purchase.service_id = data;
			this.is_netlink = this.checkServiceIsNetlink(data);
			this.is_dns = this.checkServiceIsDns(data);
			if (this.is_netlink == true) this.showNetlinkPopup = true;
			if (this.is_dns == true) {
				this.showDnsPopup = true;
				this.type = "DNS";
				this.getAllMissionsForContract(1);
			} else {
				this.type = null;
				this.getAllMissionsForContract(this.selectedContract);
			}
			this.is_dnsclient = data == this.dnsClientServiceId ? true : false;
			this.is_netlinkclient =
				data == this.netlinkClientServiceId ? true : false;
			if (this.is_dnsclient || this.is_netlinkclient) {
				this.purchase.isBillable = true;
				this.lockBillable = true;
			} else {
				this.lockBillable = false;
			}
			this.setProviderOptions(data);
		},
		is_netlink: function () {
			if (this.is_netlink) {
				//console.log("is_netlink", this.is_netlink);
			}
		},
		is_dns: function () {
			if (this.is_dns) {
				//console.log("is_dns", this.is_dns);
			}
		},
		services: function (data) {
			this.setNetlinkAndDnsId();
			if (this.is_dns) {
				//console.log("store.state.services", data);
				let dns_providers = [];
				let dns_service = data.filter(
					(service) => service.name == this.dnsServiceName
				);
				if (dns_service.length > 0) {
					this.dnsServices = dns_service;
					let dns_service_id = dns_service[0].id;
					//console.log("dns_service_id", dns_service_id);

					if (dns_service_id) {
						dns_providers = this.providers.filter((provider) => {
							let service_id_list = provider.service_id_list
								? provider.service_id_list.split(",")
								: [];
							//console.log(service_id_list);
							if (service_id_list.length > 0) {
								let service_id_found_index = service_id_list.findIndex(
									(service_id) => service_id == dns_service_id
								);
								if (service_id_found_index >= 0) return provider;
							}
						});
						//console.log("dns_providers", dns_providers);
					}
				}
				if (dns_providers.length > 0) {
					this.dnsProviders = dns_providers;
				} else {
					this.dnsProviders = this.providers;
				}
			}
		},
	},
	methods: {
		validateOne(val, name) {
			//console.log(name, val);
			let value = val;
			if (value === 0) value = "0";
			let constname = "";
			if (name == "boughtAt") {
				constname = "dateConstraint";
				this.validators[name] = new Validator({ constraintName: constname });
				if (this.purchase.boughtAt == 0 || this.purchase.boughtAt == null) {
					this.validators[name].valid = false;
					this.validators[name].errText = "Ce champ ne peut être vide.";
					this.check = false;
				} else {
					this.validators["boughtAt"].errText = "";
					this.validators[name].valid = true;
				}
			} else {
				switch (name) {
					case "price":
					case "sellPrice":
						if (value) value = String(val);
						constname = "priceConstraint";
						break;
					default:
						if (value) value = String(val);
						if (value == null) value = "";
						constname = "isNumberConstraint";
						break;
				}
				this.validators[name] = new Validator({ constraintName: constname });
				this.validators[name].check(value);
				if (val == null) this.validators[name].valid = false;
				if (
					this.validators[name].valid == false &&
					this.validators[name].errText == ""
				)
					this.validators[name].errText = "Ce champ ne peut être vide.";
				if (
					this.validators[name].valid == false &&
					this.validators[name].errText !== ""
				)
					this.check = false;
			}
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
			) {
				switch (name) {
					case "boughtAt":
						return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
					default:
						return "border: 1px solid red !important; border-radius: 5px;";
				}
			} else if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].errText == ""
			) {
				switch (name) {
					case "boughtAt":
						return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
					default:
						return "border: 1px solid green !important; border-radius: 5px;";
				}
			} else {
				return "border: none !important; border-radius: none;";
			}
		},
		addPurchase(isDNS = false, isNetlink = false) {
			return new Promise((resolve, reject) => {
				let today = new Date(Date.now());
				let formatedDate = this.purchase.boughtAt
					? this.purchase.boughtAt.substring(0, 10)
					: today.toISOString().substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";

				let period = `${this.period
					.split("/")
					.reverse()
					.join("-")}-01 02:00:00`;

				if (isDNS == true) {
					this.$refs.dnsPurchasePopup.getPurchasePrice().then((result) => {
						this.purchase.price = result;
						let missionId = this.selectedProduct;
						if (this.is_dns) {
							missionId = this.missionsOfSociety.filter(
								(mission) =>
									mission.contract_id == 1 && mission.products_id == 105
							)[0].id;
						} else if (this.orderId) {
							missionId = null;
						}
						this.$http
							.post(this.apiUrl + "purchase/add", {
								price:
									this.selectedService ==
									this.convertFrenchNumberToInternational(this.purchase.price),
								recurrence: this.purchase.recurrence,
								sell_price: this.convertFrenchNumberToInternational(
									this.purchase.sellPrice
								),
								margin_price: this.convertFrenchNumberToInternational(
									this.purchase.marginPrice
								),
								margin_rate: this.purchase.marginRate,
								is_billable: this.purchase.isBillable,
								commentary: this.purchase.commentary,
								bought_at: formatedDate,
								contract_id: 1,
								contract_society_id: this.selectedSociety,
								users_id: this.selectedProvider,
								service_id: this.selectedService,
								is_delivered: 0,
								recurrence_active: this.purchase.recurrence,
								user_id: this.activeUser.id,
								period_date: period,
								mission_id: missionId,
							})
							.then((res) => {
								// //console.log(res)
								this.purchaseId = res.data.insertId;
								/*
								 * //console.log(this.purchaseId)
								 * this.showNetlinkPopup = true
								 */
								if (this.orderId)
									this.$http.get(
										this.apiUrl +
											"orders/add/purchase/" +
											res.data.insertId +
											"/" +
											this.orderId
									);
								else this.$store.dispatch("getAllPurchasesWithRecurring");
								// Send a success notification to the user
								this.$vs.notify({
									title: "Succès",
									text: "Achat ajouté avec succès.",
								});
								if (this.orderId) this.$emit("close-popup");
								resolve(res.data.insertId);
							})
							.catch((err) => {
								//console.log(err);
								this.$vs.notify({
									title: "Echec",
									text: "L'achat n'a pas été ajouté.",
								});
								reject(null);
							});
					});
				} else {
					let missionId = this.selectedProduct;
					if (this.is_dns) {
						missionId = this.missionsOfSociety.filter(
							(mission) =>
								mission.contract_id == 1 && mission.products_id == 105
						)[0].id;
					} else if (this.orderId) {
						missionId = null;
					}
					this.$http
						.post(this.apiUrl + "purchase/add", {
							price:
								this.selectedService == this.netlinkServiceId
									? this.$refs.netlinkPopup.getPurchasePrice()
									: this.convertFrenchNumberToInternational(
											this.purchase.price
									  ),
							recurrence: this.purchase.recurrence,
							sell_price: this.convertFrenchNumberToInternational(
								this.purchase.sellPrice
							),
							margin_price: this.convertFrenchNumberToInternational(
								this.purchase.marginPrice
							),
							margin_rate: this.purchase.marginRate,
							is_billable: this.purchase.isBillable,
							commentary: this.purchase.commentary,
							bought_at: formatedDate,
							contract_id: this.$props.contractId
								? this.$props.contractId
								: this.selectedContract,
							contract_society_id: this.selectedSociety,
							users_id: this.selectedProvider,
							service_id: this.selectedService,
							is_delivered: 0,
							recurrence_active: this.purchase.recurrence,
							user_id: this.activeUser.id,
							period_date: period,
							mission_id: missionId,
						})
						.then((res) => {
							// //console.log(res)
							this.purchaseId = res.data.insertId;
							/*
							 * //console.log(this.purchaseId)
							 * this.showNetlinkPopup = true
							 */
							if (this.orderId)
								this.$http.get(
									this.apiUrl +
										"orders/add/purchase/" +
										res.data.insertId +
										"/" +
										this.orderId
								);
							else this.$store.dispatch("getAllPurchasesWithRecurring");
							// Send a success notification to the user
							this.$vs.notify({
								title: "Succès",
								text: "Achat ajouté avec succès.",
							});
							if (this.orderId) this.$emit("close-popup");
							resolve(res.data.insertId);
						})
						.catch((err) => {
							//console.log(err);
							this.$vs.notify({
								title: "Echec",
								text: "L'achat n'a pas été ajouté.",
							});
							reject(null);
						});
				}
				/*
				 * else if(isNetlink){
				 *   purchasePrice
				 *   this.purchase = this.$refs.netlinkPopup.getPurchaseData()
				 * }
				 */
			});
		},

		addDNS() {
			// CREATE DNS OBJECT
			return new Promise((resolve, reject) => {
				this.oneDns = this.$refs.dnsPurchasePopup.getDnsData();
				//console.log("this.purchaseId", this.purchaseId);
				if (this.purchaseId) {
					//console.log(this.purchaseId);
					this.oneDns.purchase_id = this.purchaseId;
				}
				if (this.providerId) {
					//console.log(this.providerId);
					this.oneDns.provider_id = this.providerId;
				}
				let today = new Date(Date.now());
				let formatedDate = this.purchase.boughtAt
					? this.purchase.boughtAt.substring(0, 10)
					: today.toISOString().substring(0, 10);

				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				this.$refs.dnsPurchasePopup
					.submitAllDns(this.purchaseId, formatedDate, this.providerId)
					.then((result) => {
						resolve(result);
					})
					.catch((err) => {
						reject(err);
					});
				/*
				 * this.oneDns.purchase_date = formatedDate
				 * this.oneDns.renew_date = formatedDate
				 * let newDns = new Dns(this.oneDns)
				 * //console.log(newDns)
				 * newDns.create((err, res) => {
				 *   if(err){
				 *     //console.log(err)
				 *     reject(err)
				 *   }
				 *   if(res) {
				 *     //console.log(res)
				 *     this.$store.dispatch("getAllDns");
				 *     resolve(res.data.insertId)
				 *   }
				 * })
				 */
			});
		},

		createNetlink(isDNS, netlink) {
			return new Promise((resolve, reject) => {
				/*
				 * this.netlink =
				 * this.netlink.landingPage = this.netlink.landingPage;
				 * this.netlink.urlBought = this.netlink.urlBought;
				 */

				/*
				 * if(isDNS){
				 *   netlink.dns_id = this.selectedDns
				 * }
				 */

				if (this.purchaseId) {
					//console.log(this.purchaseId);
					netlink.purchase_id = this.purchaseId;
				}
				//console.log("this.society_id", this.selectedSociety);
				if (this.selectedSociety) {
					//console.log(this.selectedSociety);
					netlink.society_id = this.selectedSociety;
				}

				//console.log("this.selectedContract", this.selectedContract);
				if (this.selectedContract) {
					//console.log(this.selectedContract);
					netlink.contract_id = this.selectedContract;
				}

				/*
				 * let newNetlink = new Netlink(netlink)
				 * //console.log(newNetlink)
				 */
				netlink.create((err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							//console.log(res.data.insertId);
							this.$store.dispatch("getAllNetlink");
							netlink.id = res.data.insertId;
							// this.netlink_list.push(newNetlink)
							resolve(res.data.insertId);
						}
				});
			});
		},

		addNetlink(isDNS = false) {
			// IMPLEMENT DNS LINKING
			return new Promise((resolve, reject) => {
				this.netlink_list = this.$refs.netlinkPopup.getNetlinkListData();
				let requests = [];
				for (let netlink of this.netlink_list) {
					requests.push(this.createNetlink(isDNS, netlink));
				}
				Promise.all(requests).then((responses) => {
					resolve(responses);
				});
			});
		},

		submitForm() {
			this.check = true;
			let fields = [
				"selectedSociety",
				"selectedContract",
				"selectedService",
				"selectedProvider",
				"selectedProduct",
				"price",
				"sellPrice",
			];
			let fieldsVal = [
				this.selectedSociety,
				this.selectedContract,
				this.selectedService,
				this.selectedProvider,
				this.selectedProduct,
				this.purchase.price,
				this.purchase.sellPrice,
			];
			let constname = "";

			if (this.is_dns) {
				fields = [
					"selectedSociety",
					"selectedService",
					"selectedProvider",
					"price",
					"sellPrice",
				];
				fieldsVal = [
					this.selectedSociety,
					this.selectedService,
					this.selectedProvider,
					this.purchase.price,
					this.purchase.sellPrice,
				];
			}

			for (let i = 0; i < fields.length; i++) {
				let value = fieldsVal[i];
				if (value === 0) value = "0";
				switch (fields[i]) {
					case "price":
					/*
					 * case "marginPrice":
					 * case "marginRate":
					 */
					case "sellPrice":
						if (value) value = String(value);
						constname = "priceConstraint";
						break;
					default:
						if (value) value = String(value);
						if (value == null) value = "";
						constname = "isNumberConstraint";
						break;
				}

				this.validators[fields[i]] = new Validator({
					constraintName: constname,
				});
				this.validators[fields[i]].check(value);
				if (fieldsVal[i] == null) this.validators[fields[i]].valid = false;
				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				)
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
				if (fields[i] == "sellPrice" || fields[i] == "price") {
					if ([29, 30].includes(this.selectedService)) {
						// this.purchase[fields[i]] = null;
						this.validators["sellPrice"].valid = true;
						this.validators["sellPrice"].errText = "";
						// this.purchase.price = 0;
						this.validators["price"].valid = true;
						this.validators["price"].errText = "";
					}
				}
				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText !== ""
				)
					this.check = false;
			}

			this.$forceUpdate();

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.purchase.price = Number(
					String(this.purchase.price).replace(",", ".")
				);
				this.purchase.sellPrice = Number(
					String(this.purchase.sellPrice).replace(",", ".")
				);
				this.purchase.marginPrice = Number(
					String(this.purchase.marginPrice).replace(",", ".")
				);
				this.purchase.marginRate = Number(
					String(this.purchase.marginRate).replace(",", ".")
				);
				return new Promise((resolve, reject) => {
					if (this.selectedService == this.dnsServiceId) {
						/*
						 * if(this.showNewDNS == true){
						 * Purchase DNS
						 */
						this.addPurchase(true)
							.then((result) => {
								// Add DNS
								this.addDNS()
									.then((result2) => {
										// this.selectedDns = result2
										if (this.orderId) this.$emit("close-popup");
										else this.returnPrevRoute();
										resolve(result2);
										/*
										 * Add Netlink to DNS
										 * this.addNetlink(true)
										 * .then(result3 => {this.returnPrevRoute(); resolve(result3)})
										 * .catch(err3 => {//console.log(err3); reject(err3)})
										 */
									})
									.catch((err2) => {
										//console.log(err2); reject(err2);
									});
							})
							.catch((err) => {
								//console.log(err); reject(err);
							});
						/*
						 * }
						 * else{
						 *   // Add Netlink to DNS
						 *   this.addNetlink(true)
						 *   .then(result => {this.returnPrevRoute(); resolve(result)})
						 *   .catch(err => {//console.log(err); reject(err)})
						 * }
						 */
					} else if (this.selectedService == this.netlinkServiceId) {
						// Purchase Netlink
						this.addPurchase()
							.then((result) => {
								// Add Netlink
								this.addNetlink()
									.then((result2) => {
										if (this.orderId) this.$emit("close-popup");
										else this.returnPrevRoute();
										resolve(result2);
									})
									.catch((err2) => {
										//console.log(err2); reject(err2);
									});
							})
							.catch((err) => {
								//console.log(err); reject(err);
							});
					} else {
						// Purchase Netlink
						this.addPurchase()
							.then((result) => {
								if (this.orderId) this.$emit("close-popup");
								else this.returnPrevRoute();
								resolve(result);
							})
							.catch((err) => {
								//console.log(err); reject(err);
							});
					}
				});
			}
		},

		/**
		 * Send the data to tha API to create the new purchase
		 */
		formSubmitted() {
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http
				.post(this.apiUrl + "purchase/add", {
					price: this.convertFrenchNumberToInternational(this.purchase.price),
					recurrence: this.purchase.recurrence,
					sell_price: this.convertFrenchNumberToInternational(
						this.purchase.sellPrice
					),
					margin_price: this.convertFrenchNumberToInternational(
						this.purchase.marginPrice
					),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: this.purchase.contract_id,
					contract_society_id: this.purchase.contract_society_id,
					users_id: this.purchase.users_id,
					service_id: this.purchase.service_id,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence,
					user_id: this.activeUser.id,
				})
				.then((res) => {
					//console.log(res);
					this.$store.dispatch("getAllPurchasesWithRecurring");
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Achat ajouté avec succès.",
					});
					this.$router.go(-1);
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Echec",
						text: "L'achat n'a pas été ajouté.",
					});
				});
		},

		/**
		 * Send the data to tha API to create the new purchase and show Netlink
		 */
		formSubmittedAndShowNetlink() {
			this.purchaseLocked = true;
			this.purchaseDefinitiveLock = true;
			this.showNetlinkPopup = true;
			/*
			 * let formatedDate = this.purchase.boughtAt.substring(0,10)
			 * formatedDate = formatedDate.split('/').reverse().join('-')
			 * formatedDate = formatedDate + " 02:00:00"
			 * this.$http.post(this.apiUrl + "purchase/add", {
			 *   price: this.convertFrenchNumberToInternational(this.purchase.price),
			 *   recurrence: this.purchase.recurrence,
			 *   margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
			 *   margin_rate: this.purchase.marginRate,
			 *   is_billable: this.purchase.isBillable,
			 *   commentary: this.purchase.commentary,
			 *   bought_at: formatedDate,
			 *   contract_id: this.purchase.contract_id,
			 *   contract_society_id: this.purchase.contract_society_id,
			 *   users_id: this.purchase.users_id,
			 *   service_id: this.purchase.service_id,
			 *   is_delivered: 0,
			 *   recurrence_active: this.purchase.recurrence,
			 *   user_id: this.activeUser.id
			 * }).then(res => {
			 *   //console.log(res)
			 *   this.purchaseId = res.data.insertId
			 *   //console.log(this.purchaseId)
			 *   this.showNetlinkPopup = true
			 *   this.$store.dispatch("getAllPurchasesWithRecurring");
			 *   // Send a success notification to the user
			 *   this.$vs.notify({title:'Succès',text:"Achat ajouté avec succès."})
			 * }).catch(err => {
			 *   //console.log(err)
			 *   this.$vs.notify({title:'Echec',text:"L'achat n'a pas été ajouté."})
			 * })
			 */
		},

		formSubmittedAndShowDns() {
			/*
			 * this.purchaseLocked = true
			 * this.purchaseDefinitiveLock = true
			 * let formatedDate = this.purchase.boughtAt.substring(0,10)
			 * formatedDate = formatedDate.split('/').reverse().join('-')
			 * formatedDate = formatedDate + " 02:00:00"
			 * this.$http.post(this.apiUrl + "purchase/add", {
			 *   price: this.convertFrenchNumberToInternational(this.purchase.price),
			 *   recurrence: this.purchase.recurrence,
			 *   margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
			 *   margin_rate: this.purchase.marginRate,
			 *   is_billable: this.purchase.isBillable,
			 *   commentary: this.purchase.commentary,
			 *   bought_at: formatedDate,
			 *   contract_id: this.purchase.contract_id,
			 *   contract_society_id: this.purchase.contract_society_id,
			 *   users_id: this.purchase.users_id,
			 *   service_id: this.purchase.service_id,
			 *   is_delivered: 0,
			 *   recurrence_active: this.purchase.recurrence
			 * }).then(res => {
			 *   //console.log(res)
			 *   this.purchaseId = res.data.insertId
			 *   //console.log(this.purchaseId)
			 */
			this.showDnsPopup = true;
			/*
			 *   this.$store.dispatch("getAllPurchasesWithRecurring");
			 *   // Send a success notification to the user
			 *   this.$vs.notify({title:'Succès',text:"Achat ajouté avec succès."})
			 * }).catch(err => {
			 *   //console.log(err)
			 *   this.$vs.notify({title:'Echec',text:"L'achat n'a pas été ajouté."})
			 * })
			 */
		},

		enterEditMode() {
			if (!this.atLeastOneNetlink && !this.atLeastOneDns) {
				this.purchaseDefinitiveLock = false;
			}
			this.showNetlinkPopup = false;
			this.showDnsPopup = false;
			this.editPurchaseMode = true;
			this.purchaseLocked = false;
		},

		editFormSubmittedAndShowNetlink() {
			this.purchaseLocked = true;
			this.purchaseDefinitiveLock = true;
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http
				.post(this.apiUrl + "purchase/edit", {
					id: this.purchaseId,
					price: this.convertFrenchNumberToInternational(this.purchase.price),
					sell_price: this.convertFrenchNumberToInternational(
						this.purchase.sellPrice
					),
					recurrence: this.purchase.recurrence,
					margin_price: this.convertFrenchNumberToInternational(
						this.purchase.marginPrice
					),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: this.purchase.contract_id,
					contract_society_id: this.purchase.contract_society_id,
					users_id: this.purchase.users_id,
					service_id: this.purchase.service_id,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence,
					user_id: this.purchase.user_id,
					mission_id: this.purchase.mission_id,
				})
				.then((res) => {
					//console.log(res);
					this.showNetlinkPopup = true;
					this.$store.dispatch("getAllPurchasesWithRecurring");
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Achat modifié avec succès.",
					});
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Echec",
						text: "L'achat n'a pas été modifié.",
					});
				});
		},

		editFormSubmittedAndShowDns() {
			/*
			 * this.purchaseLocked = true
			 * this.purchaseDefinitiveLock = true
			 */
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http
				.post(this.apiUrl + "purchase/edit", {
					id: this.purchaseId,
					price: this.convertFrenchNumberToInternational(this.purchase.price),
					sell_price: this.convertFrenchNumberToInternational(
						this.purchase.sellPrice
					),
					recurrence: this.purchase.recurrence,
					margin_price: this.convertFrenchNumberToInternational(
						this.purchase.marginPrice
					),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: this.purchase.contract_id,
					contract_society_id: this.purchase.contract_society_id,
					users_id: this.purchase.users_id,
					service_id: this.purchase.service_id,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence,
					user_id: this.purchase.user_id,
					mission_id: this.purchase.mission_id,
				})
				.then((res) => {
					//console.log(res);
					this.showDnsPopup = true;
					this.$store.dispatch("getAllPurchasesWithRecurring");
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Achat modifié avec succès.",
					});
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Echec",
						text: "L'achat n'a pas été modifié.",
					});
				});
		},

		editFormSubmitted() {
			this.purchaseLocked = true;
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http
				.post(this.apiUrl + "purchase/edit", {
					id: this.purchaseId,
					price: this.convertFrenchNumberToInternational(this.purchase.price),
					sell_price: this.convertFrenchNumberToInternational(
						this.purchase.sellPrice
					),
					recurrence: this.purchase.recurrence,
					margin_price: this.convertFrenchNumberToInternational(
						this.purchase.marginPrice
					),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: this.purchase.contract_id,
					contract_society_id: this.purchase.contract_society_id,
					users_id: this.purchase.users_id,
					service_id: this.purchase.service_id,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence,
					user_id: this.purchase.user_id,
					mission_id: this.purchase.mission_id,
				})
				.then((res) => {
					//console.log(res);
					this.$store.dispatch("getAllPurchasesWithRecurring");
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Achat modifié avec succès.",
					});
					this.$router.go(-1);
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Echec",
						text: "L'achat n'a pas été modifié.",
					});
				});
		},

		/**
		 * Send the data to tha API to create the new netlinks
		 */
		netlinkSubmitted() {
			this.$router.go(-1);
		},

		updatePurchasePrice(purchasePrice, id) {
			return new Promise((resolve, reject) => {
				this.$http
					.post(this.apiUrl + "purchase/editprice", {
						id: id,
						price: purchasePrice,
					})
					.then((result) => {
						resolve(true);
					});
			});
		},

		submitPurchase() {
			return new Promise((resolve, reject) => {
				let formatedDate = this.purchase.boughtAt.substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				this.$http
					.post(this.apiUrl + "purchase/add", {
						price: this.convertFrenchNumberToInternational(this.purchase.price),
						sell_price: this.convertFrenchNumberToInternational(
							this.purchase.sellPrice
						),
						recurrence: this.purchase.recurrence,
						margin_price: this.convertFrenchNumberToInternational(
							this.purchase.marginPrice
						),
						margin_rate: this.purchase.marginRate,
						is_billable: this.purchase.isBillable,
						commentary: this.purchase.commentary,
						bought_at: formatedDate,
						contract_id: 1,
						contract_society_id: 206,
						users_id: this.purchase.users_id,
						service_id: this.purchase.service_id,
						is_delivered: 0,
						recurrence_active: this.purchase.recurrence,
						user_id: this.activeUser.id,
						mission_id: this.purchase.mission_id,
					})
					.then((res) => {
						//console.log(res);
						this.purchaseId = res.data.insertId;
						//console.log(this.purchaseId);
						this.$store.dispatch("getAllPurchasesWithRecurring");
						// Send a success notification to the user
						this.$vs.notify({
							title: "Succès",
							text: "Achat ajouté avec succès.",
						});
						resolve(res.data.insertId);
					})
					.catch((err) => {
						//console.log(err);
						this.$vs.notify({
							title: "Echec",
							text: "L'achat n'a pas été ajouté.",
						});
						reject(err);
					});
			});
		},

		dnsSubmitted() {
			// GET PURCHASE PRICE
			this.$refs.dnsPopup.getPurchasePrice().then((purchasePrice) => {
				this.purchase.price = purchasePrice;
				// SUBMIT PURCHASE
				this.submitPurchase().then((purchaseId) => {
					let formatedDate = this.purchase.boughtAt.substring(0, 10);
					formatedDate = formatedDate.split("/").reverse().join("-");
					formatedDate = formatedDate + " 02:00:00";
					// SUBMIT DNSs
					this.$refs.dnsPopup
						.submitAllDns(purchaseId, formatedDate, this.purchase.users_id)
						.then((dns_reponses) => {
							this.$vs.notify({
								title: "Succès",
								text: "Noms de domaines ajoutés avec succès.",
							});
							this.returnPrevRoute();
						})
						.catch((dns_err) => {
							this.$vs.notify({
								title: "Echec",
								text: "Une erreur est survenue lors de l'ajout des noms de domaines.",
							});
						});
				});
			});
			//console.log("dnsSubmitted");
			/*
			 * this.$refs.dnsPopup.newDns()
			 *   .then(res => {
			 *     this.$router.go(-1);
			 *   })
			 *   .catch(err => {
			 *     //console.log(err)
			 *   })
			 */
		},

		displayMissionsPopup() {
			this.showMissionsPopup = true;
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},

		getAllServices() {
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */

		getAllProductsCategories() {
			this.$store.dispatch("getAllProductsCategories");
		},

		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},
		getAllContractsForSociety(societyId) {
			Contract.getContractsforSociety(societyId, (err, res) => {
				if (err) console.log(err);
				if (res) {
					if (this.activeUser.type == 9 && this.activeUser.hasAccess == 1) {
						//if user is super admin
						this.contractOptions = res.filter((row) =>
							[1, 3, 4, 9].includes(row.status)
						);
					} else {
						this.contractOptions = res.filter((row) =>
							[1, 3, 4].includes(row.status)
						);
					}
				}
			});
			console.log("getAllContractsForSociety", this.contractOptions.length);
		},
		getAllMissionsForContract(contractId) {
			//console.log(contractId);
			Mission.getMissionsForContract(contractId, (err, res) => {
				if (err) console.log(err);
				if (res) {
					this.missionsOfSociety = res;
					let missionList = [];
					for (let mission of this.missionsOfSociety) {
						let item;

						/*
						 * if(mission.commentary){
						 * 	if(this.products.filter(product => product.id == mission.products_id && product.sub_category == 7).length > 0) item = `${this.products.filter(product => product.id == mission.products_id && product.sub_category == 7)[0].perform}: ${mission.commentary}`;
						 * }else{
						 * 	if(this.products.filter(product => product.id == mission.products_id && product.sub_category == 7).length > 0) item = this.products.filter(product => product.id == mission.products_id && product.sub_category == 7)[0].perform;
						 * }
						 */
						if (mission.commentary) {
							if (
								this.products.filter(
									(product) => product.id == mission.products_id
								).length > 0
							)
								item = `${
									this.products.filter(
										(product) => product.id == mission.products_id
									)[0].perform
								}: ${mission.commentary}`;
						} else {
							if (
								this.products.filter(
									(product) => product.id == mission.products_id
								).length > 0
							)
								item = this.products.filter(
									(product) => product.id == mission.products_id
								)[0].perform;
						}
						if (item) missionList.push([mission.id, item]);
					}
					this.productOptions = missionList;
					if (this.productOptions.length > 0)
						this.selectedProduct = this.productOptions[0][0];
					else this.selectedProduct = null;
				}
			});
			console.log("getAllMissionsForContract");
		},

		setProviderOptions(service_id) {
			let providerOptions = [];
			for (let i = 0; i < this.providers.length; i++) {
				if (this.providers[i].service_id_list) {
					let providerServices = this.providers[i].service_id_list.split(",");
					// //console.log("providerServices", providerServices, service_id)
					if (providerServices.includes(service_id.toString())) {
						// //console.log("INCLUDES")
						providerOptions.push(this.providers[i]);
					}
				}
			}

			// this.providers.filter(provider => provider.service_id_list.split(',').includes(service_id))
			this.providerOptions = providerOptions;
			this.dnsProviders = providerOptions;
			if (providerOptions.length > 0) {
				this.selectedProvider = providerOptions[0].id;
			} else this.selectedProvider = null;
		},
		setServiceOptions(provider_id) {
			let foundProvider = this.providers.find(
				(provider) => provider_id == provider.id
			);
			let provider_service_id_list = foundProvider.service_id_list
				? foundProvider.service_id_list.split(",")
				: [];
			if (provider_service_id_list.length > 0) {
				return this.type == "DNS"
					? provider_service_id_list.filter(
							(id) => id == this.dnsServices[0].id
					  )
					: provider_service_id_list;
			} else {
				return [];
			}
			// return this.type == "DNS" ? foundProvider.service_id_list.split(",") : foundProvider.service_id_list.split(",")
		},

		getServiceName(service_id) {
			let service = this.services.find(
				(service_element) => service_element.id == service_id
			);
			return service.name;
		},

		getServiceId(service_name) {
			let service = this.services.find(
				(service_element) => service_element.name == service_name
			);
			return service.id;
		},

		setNetlinkAndDnsId() {
			this.netlinkServiceId = this.getServiceId(this.netlinkServiceName);
			this.dnsServiceId = this.getServiceId(this.dnsServiceName);
			this.dnsClientServiceId = this.getServiceId(this.dnsClientServiceName);
			this.netlinkClientServiceId = this.getServiceId(
				this.netlinkClientServiceName
			);
		},

		// [netlinkServiceId, dnsServiceId].includes(selectedService)

		checkServiceIsNetlink(service_id) {
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined) {
				if (service.name == this.netlinkServiceName) {
					return true;
				}
			}
			return false;
		},

		checkServiceIsDns(service_id) {
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined) {
				if (service.name == this.dnsServiceName) {
					return true;
				}
			}
			return false;
		},

		checkNetlinkNumber(netlinkNumber) {
			if (netlinkNumber >= 1) {
				this.atLeastOneNetlink = true;
			} else {
				this.atLeastOneNetlink = false;
				if (!this.purchaseLocked) {
					this.purchaseDefinitiveLock = false;
				}
			}
		},

		checkDnsNumber(dnsNumber) {
			if (dnsNumber >= 1) {
				this.atLeastOneDns = true;
			} else {
				this.atLeastOneDns = false;
				if (!this.purchaseLocked) {
					this.purchaseDefinitiveLock = false;
				}
			}
		},
	},
};
</script>

<style>
#product_options > .input-select-con {
	width: 400px;
}

.nowrap {
	display: flex;
	align-items: baseline;
}

.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}
</style>
